import { render } from "./BotaoCadastrar.vue?vue&type=template&id=61d8f48b&ts=true"
import script from "./BotaoCadastrar.vue?vue&type=script&lang=ts"
export * from "./BotaoCadastrar.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Botoes/BotaoCadastrar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61d8f48b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61d8f48b', __exports__)) {
    api.reload('61d8f48b', __exports__)
  }
  
  module.hot.accept("./BotaoCadastrar.vue?vue&type=template&id=61d8f48b&ts=true", () => {
    api.rerender('61d8f48b', render)
  })

}


export default __exports__